import React, { useEffect, useState } from "react";
import { axiosInstance } from "../../axiosConfig";
import { toast } from "react-toastify";

const TermsOfService = () => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getTermsOfService();
  }, []);

  const getTermsOfService = async () => {
    setLoading(true);
    axiosInstance
      .get(`/setting/detail?type=aboutUsDetails`)
      .then((response) => {
        const { status } = response?.data;
        if (status) {
          setContent(response?.data?.data?.termsAndConditions || "");
        }
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error?.message);
        setLoading(false);
      });
  };

  return (
    <section
      className="container terms-service"
      style={{ padding: "120px 0px 100px" }}
    >
      {loading ? (
        <p>Loading…</p>
      ) : content ? (
        <div
          className="legal-content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      ) : (
        <p>Our terms of service will be available here shortly.</p>
      )}
    </section>
  );
};

export default TermsOfService;
